/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';

class FieldError extends React.Component {
    render() {
        let error = null,
            errors = [],
            parts = [],
            keys = [],
            extractError = (source, path) => {
                if (!source || source === undefined) {
                    return null;
                }
                if (source[path[0]] !== undefined && _.isObject(source[path[0]]) && !_.isArray(source[path[0]])) {
                    return extractError(source[path[0]], path.splice(1));
                }
                return (source[path[0]]) !== undefined ? source[path[0]] : null;
            },
            extractString = (error) => {
                if (_.isString(error)) {
                    return error;
                }
                for (let key in error) {
                    return extractString(error[key]);
                }
            },
            setError = (error, errors) => {
                if (this.props.options !== undefined && this.props.options.index !== undefined && _.isNumber(this.props.options.index)) {
                    if (error.errors !== undefined && error.errors[this.props.options.index] !== undefined) {
                        for (let objKey in parts) {
                            if (error.hasOwnProperty(objKey)) {
                                errors.push(error[objKey]);
                            }
                        }
                    }
                } else if (_.isString(error)) {
                    errors.push(error);
                } else if (_.isArray(error) || _.isObject(error)) {
                    errors.push(extractString(error));
                }
            };

        parts = [this.props.field];
        if (this.props.field.match(/\./)) {
            parts = this.props.field.split(/\./);
        }

        if (this.props.errors !== null && this.props.errors.length) {
            for (let i = 0; i < this.props.errors.length; ++i) {
                if (this.props.errors[i].isNetworkError !== undefined) {
                    continue;
                }
                if (this.props.errors[i] !== null && this.props.errors[i].errors !== undefined && this.props.errors[i].errors.validation) {
                    error = extractError(this.props.errors[i].errors.validation, parts);
                    if (error) {
                        setError(error, errors);
                    }
                } else if (this.props.errors[i] !== null) {
                    error = extractError(this.props.errors[i].errors, parts);
                    if (error) {
                        setError(error, errors);
                    }
                }
            }

            if (errors.length) {
                return (
                    <div className="fieldset-error">
                        <ul className="fieldset-error-list">
                        {errors.map((error, i) => {
                            let displayError = error,
                                re = null;

                            if (this.props.errorRE !== '') {
                                if (error.match(this.props.errorRE)) {
                                    displayError = this.props.errorReplacement;
                                }
                            }

                            return (
                                <li key={'error-' + this.props.field.replace(".", "-")} className="error-list-item">{displayError}</li>
                            );
                        })}
                        </ul>
                    </div>
                );
            }
        }

		return null;

    }
}

FieldError.displayName = "FieldError";

FieldError.propTypes = {
    field: PropTypes.string,
    errors: PropTypes.array,
    errorRE: PropTypes.string,
    errorReplacement: PropTypes.string
};

FieldError.defaultProps = {
    field: '',
    errors: [],
    errorRE: '',
    errorReplacement: ''
};

export default FieldError;
